import { Typography } from "@mui/material"
import React from "react"
import { copyRightYear } from "../modules/helpers"
function Footer() {
  return (
    <div className="py-3" style={{ backgroundColor: "#3E4755" }}>
      <p className="text-center text-white mb-0">
        &copy;{copyRightYear()} GLACIER PEAK HOLISTICS TEST REGISTRATION All Rights Reserved.
      </p>

    </div>
  )
}
export default Footer
